<template>
  <div id="account">
    <section>
      <h3>プロフィール</h3>
      <el-form label-width="120px" :model="profile" ref="account">
        <el-form-item label="性別">
          <el-radio v-model="profile.gender" label="1">男性</el-radio>
          <el-radio v-model="profile.gender" label="2">女性</el-radio>
        </el-form-item>

        <el-form-item label="生年月日">
          <el-date-picker
            v-model="profile.birthday"
            type="date"
            placeholder="生年月日"
            default-value="2000-01-01">
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button size="medium" type="primary" v-on:click="changeProfile('profile')">保存</el-button>
        </el-form-item>
      </el-form>
    </section>

    <section>
      <h3>アカウント情報</h3>
      <el-form label-width="120px" :model="account" ref="account" :rules="rules">
        <el-form-item label="メールアドレス">
          <el-input size="medium" v-model="$store.state.User.email" disabled></el-input>
        </el-form-item>

        <el-form-item label="パスワード変更" prop="password"
          :rules="{required: true, message: '現在のパスワードを入力してください', trigger: 'blur'}">
          <el-input type="password" name="password" placeholder="現在のパスワード" v-model="account.password"></el-input>
        </el-form-item>
        <el-form-item prop="newpassword"
          :rules="{required: true, message: '新しいパスワードを入力してください', trigger: 'blur'}">
          <el-input type="password" name="password" placeholder="新しいパスワード" v-model="account.newpassword"></el-input>
        </el-form-item>
        <el-form-item prop="confirm">
          <el-input type="password" name="password" placeholder="新しいパスワード再入力" v-model="account.confirm"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button size="medium" type="primary" v-on:click="changePassword('account')">保存</el-button>
        </el-form-item>
      </el-form>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'account',
  created: function () {
    if (!this.userProfile.gender) {
      var self = this
      this.$store.dispatch('User/getProfile').then(function (response) {
        self.profile = response.body
      })
    } else {
      this.profile = this.userProfile
    }
  },
  data () {
    var self = this
    var validateConfirm = function (rule, value, callback) {
      if (value === '') {
        callback(new Error('確認用パスワードを入力してください'))
      } else if (value !== self.account.newpassword) {
        callback(new Error('確認用パスワードが一致しません'))
      } else {
        callback()
      }
    }
    return {
      profile: {
        gender: '1',
        birthday: ''
      },
      account: {
        password: '',
        newpassword: '',
        confirm: ''
      },
      rules: {
        confirm: [
          { validator: validateConfirm, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters('User', ['userProfile'])
  },
  methods: {
    changeProfile () {
      var profile = {
        gender: this.profile.gender,
        birthday: this.formatDate(this.profile.birthday, 'YYYY-MM-DD')
      }
      var self = this
      this.$store.dispatch('User/changeProfile', {profile: profile}).then(function (response) {
        if (response.result) {
          self.errorMessage(response.message)
          self.account = {
            password: '',
            newpassword: '',
            confirm: ''
          }
        } else {
          self.errorMessage(response.message)
        }
      })
    },
    changePassword (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var self = this
          this.$http.post('/user/change', {password: this.account.password, newpassword: this.account.newpassword}).then(function (response) {
            if (response.result) {
              self.successMessage(response.message)
              self.account = {
                password: '',
                newpassword: '',
                confirm: ''
              }
            } else {
              self.errorMessage(response.message)
            }
          })
        } else {
          console.log('error changePassword')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.el-form{
  width:480px;
}
</style>



// WEBPACK FOOTER //
// src/components/04-pages/Account.vue